/*
 * Reveals the "Read more" toggle on testimonials whose text is actually
 * clipped, and expands them in place.
 *
 * The button ships hidden and is only shown once the clamp is measured, so a
 * short review never gets a toggle that does nothing. The clamp itself is CSS
 * (`scripting: enabled` in section-testimonials.css), which means the full
 * text is always in the DOM — this script only decides what is visible.
 */
if (!customElements.get('testimonial-expanders')) {
  class TestimonialExpanders {
    constructor(root) {
      this.root = root;
      this.pairs = [];

      root.querySelectorAll('.testimonial-card__more').forEach((button) => {
        const text = root.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`);
        if (!text) return;

        this.pairs.push({ button, text });
        button.addEventListener('click', () => this.toggle(button, text));
      });

      if (this.pairs.length === 0) return;

      this.sync = this.sync.bind(this);
      this.sync();

      // The clamp is measured, so anything that changes the card's width or
      // the font it renders in has to re-run it.
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.sync);
        this.observer.observe(root);
      } else {
        window.addEventListener('resize', this.sync);
      }

      document.fonts?.ready.then(this.sync);
    }

    sync() {
      this.pairs.forEach(({ button, text }) => {
        // An expanded card always keeps its toggle: collapsing it is the only
        // way back, and measuring it while open would say it no longer overflows.
        if (text.classList.contains('is-expanded')) return;
        button.hidden = text.scrollHeight <= text.clientHeight + 1;
      });
    }

    toggle(button, text) {
      const expanded = text.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      button.textContent = expanded ? button.dataset.less : button.dataset.more;
      if (!expanded) this.sync();
    }
  }

  const init = (scope) => {
    scope.querySelectorAll('.testimonials').forEach((root) => {
      if (root.dataset.testimonialsReady) return;
      root.dataset.testimonialsReady = 'true';
      new TestimonialExpanders(root);
    });
  };

  // customElements.get() above is only used as a run-once guard, so register a
  // real (unused) element to keep that guard honest if the asset loads twice.
  customElements.define('testimonial-expanders', class extends HTMLElement {});

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  // The theme editor re-renders a section into a fresh subtree.
  document.addEventListener('shopify:section:load', (event) => init(event.target));
}
